<template>
  <div>
      <HeaderSection icon="fa-inbox" title="Bandeja de solicitudes">
          <template slot="buttons">
              <el-button
                      size="medium"
                      type="danger"
                      icon="el-icon-arrow-left"
                      @click="goToIndex">
                  Regresar
              </el-button>
              <!-- <el-tooltip class="item" effect="dark"
                          content="Descargar el contenido de la tabla en formato excel"
                          placement="top">
                  <el-button
                          size="medium"
                          type="success"
                          @click.prevent="downloadFile"
                          icon="fas fa-file-excel">
                      Descargar
                  </el-button>
              </el-tooltip> -->

              <el-tooltip class="item" effect="dark"
                          content="Agregar registro"
                          v-if="profile == 2 && disableRegister === false"
                          placement="top">
                  <el-button
                          size="medium"
                          type="primary"
                          icon="fas fa-plus"
                          @click="$router.push('/solicitudes/alta')">
                      Agregar
                  </el-button>
              </el-tooltip>

          </template>
      </HeaderSection>
      <br>
      <el-row :gutter="2">
          <el-col :span="8">
              <el-form>
                  <el-form-item label="Periodo">
                      <el-col :span="8">
                          <el-select
                                  style="width:100%"
                                  v-model="periodSelected"
                                  filterable
                                  clearable
                                  placeholder="Seleccionar Periodo">
                              <el-option
                                      v-for="(item,key) in periods"
                                      :key="key"
                                      :label="item.name"
                                      :value="item.id">
                              </el-option>
                          </el-select>
                      </el-col>
                  </el-form-item>
              </el-form>
          </el-col>
          <el-col :span="16">

              <UserInformation/>
          </el-col>
      </el-row>
      <br>

      <div v-if="disableRegister === true">
          <el-alert
                  title="Registros deshabilitados"
                  description="No se pueden realizar nuevos registros debido a que se encuentra fuera del periodo de registros."
                  type="warning"
                  :closable="true"
                  show-icon>
          </el-alert>
      </div>
      <br>

      <inbox :period="periodSelected"></inbox>
  </div>
</template>

<script>
  import HeaderSection from '@/components/partials/HeaderSection';
  import {EventBus} from '@/components/views/acquisition/inbox/EventBus.js';
  import inbox from '@/components/views/acquisition/inbox/inboxTable';
  import UserInformation from '@/components/partials/UserInformation'


  export default {
      components: {
          HeaderSection,
          inbox,
          UserInformation
      },
      data() {
          return {
              download: false,
              filters: {
                  searchKeyword: '',
                  perPage: 10
              },
              periodSelected: 7,
              periods: [
                  {
                      id: 1,
                      name: '2019'
                  },
                  {
                      id: 2,
                      name: '2020'
                  },
                  {
                      id: 3,
                      name: '2021'
                  },
                  {
                      id: 4,
                      name: '2022'
                  },
                  {
                      id: 5,
                      name: '2023'
                  },
                  {
                      id: 6,
                      name: '2024'
                  },
                  {
                        id: 7,
                        name: '2025'
                  }
              ]
          }
      },
      mounted() {
          EventBus.$on('acquisitions-founded', (data) => {
              this.download = data.flag;
              this.filters = data.filters;
          });
      },
      computed: {
          disableRegister() {
              return this.$store.state.user.disableRegister;
          },
          profile() {
              return this.$store.state.user.profile;
          },
      },
      methods: {
          showLoading(message) {
              this.$store.dispatch(
                  'loading/spinner',
                  {msg: message, status: true},
                  {root: true}
              );
          },
          hideLoading() {
              this.$store.dispatch('loading/spinner', {}, {root: true});
          },
          goToIndex() {
              this.$router.push('/');
          },
          downloadFile() {
              var url = '/api/acquisitions/acquisitions-excel';
              this.getFileUrl(url);
          },
          getFileUrl(url) {
              let _this = this;
              _this.showLoading('Descargando documento...');

              let filters = this.filters;

              axios.get(url, {responseType: 'blob', params: {filters}})
                  .then(response => {
                      let now = new Date().toLocaleDateString();
                      const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                      const link = document.createElement('a');
                      link.href = linkUrl;

                      link.setAttribute('download', 'adquisiciones' + ' - ' + now + '.xlsx');
                      document.body.appendChild(link);
                      link.click();
                      _this.hideLoading();
                      _this.$notify({
                          title: 'Éxito',
                          message: 'Fue generado el reporte en excel',
                          type: 'success'
                      });
                  })
                  .catch(error => {
                      _this.hideLoading();
                      _this.$notify({
                          title: 'Error',
                          message: 'No fue posible realizar la descarga, inténtelo nuevamente.',
                          type: 'warning'
                      });
                  });
          },

      }
  }
</script>

<style scoped>
  .custom-title {
      margin: 0;
      padding-top: 0.25em;
  }
</style>
